<template>
    <div class="popBg">
        <div class="popBox">
            <el-card class="box-card">
                <div slot="header" class="title clearfix">
                    <span>会员充值</span>
                    <a href="javascript:void(0);" class="closeBtn" @click="cancel"><i class="el-icon-circle-close"></i></a>
                </div>
                <div class="popBody" ref="popBody">
                    <div class="user-head">
                        <div class="avatar">
                            <img v-if="userInfo.avatar" :src="userInfo.avatar" class="avatar">
                            <span v-else class="no-avatar"><i class="el-icon-user"></i></span>
                        </div>
                        <div class="info">
                            <div class="nickname"><span>昵称：</span>{{userInfo.nickname}}</div>
                            <div class="vip_name"><span>会员等级：</span>{{userInfo.vip_name ? userInfo.vip_name : "无"}}</div>
                            <div class="mobile"><span>联系电话：</span>{{userInfo.mobile}}</div>
                        </div>
                    </div>
                    <div class="blank10"></div>
                    <!--<div class="blank10"></div>-->
                    <div class="form-box">
                        <div class="form-line">
                            <div class="label">当前余额：</div>
                            <div class="value red">￥{{userInfo.money}}</div>
                        </div>
                        <div class="form-line">
                            <div class="label">充值金额：</div>
                            <div class="value"><el-input type="number" v-model="form.payMoney" placeholder="请输入充值金额(元)"></el-input></div>
                        </div>
                        <!--<div class="form-line">-->
                            <!--<div class="label">员工提成：</div>-->
                            <!--<div class="value"><el-input v-model="form.staffIncome" placeholder="请输入员工提成金额"></el-input></div>-->
                        <!--</div>-->
                    </div>
                </div>
                <div class="popFoot">
                    <el-button type="primary" @click="success"><div style="width: 80px;">立即充值</div></el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PayMoneyBox",
        data: () => ({
            form: {}
        }),
        props: ["userInfo"],
        methods: {
            success: function () {
                let data = Object.assign(this.form, {
                    storeUid: this.userInfo.store_uid
                });
                this.$emit("payed", data);
            },
            cancel: function () {
                this.$emit("payed", false);
            }
        }
    }
</script>

<style scoped>
    .popBg{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.5);
    }
    .popBox{
        margin: 50px auto 0;
        width: 500px;
    }
    .popBox .title{
        position: relative;
        font-size: 18px;
    }
    .popBox .closeBtn{
        position: absolute;
        right: 0px;
        top: 0px;
        font-size: 24px;
        color: #777777;
    }
    .popBox .closeBtn:hover{
        color: #000000;
    }
    .popBody{
        max-height: 300px;
    }
    .popFoot{
        padding-top: 20px;
        padding-bottom: 10px;
        text-align: center;
    }
    .popBody .form-box{

    }
    .form-box .form-line{
        display: flex;
        padding: 10px 20px;
        border-bottom: 1px solid #EBEEF5;
        line-height: 40px;
    }
    .form-box .label{
        width: 80px;
        text-align: right;
        margin-right: 0px;
    }
    .form-box .value{
        flex: 1;
    }

    .popBody .user-head{
        display: flex;
        padding: 0px 20px;
    }
    .user-head .avatar{
        width: 80px;
        height: 80px;
        margin-right: 10px;
        border-radius: 5px;
    }
    .user-head .info{
        flex: 1;
        line-height: 28px;
    }
    .user-head .info span{
        color: #777777;
    }
    .user-head .info .nickname{

    }
    .no-avatar{
        border-radius: 5px;
        width: 80px;
        height: 80px;
        line-height: 80px;
    }
</style>